module.exports = __webpack_public_path__ + "vi.9b32e9eaa86eef7a0d13.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/flag-icon-css/flags/vi.svg
// module id = ../../../../../src/scss/icons/flag-icon-css/flags/vi.svg
// module chunks = styles